// Internet Explorer 6-11
const isIE = /* @cc_on!@ */false || !!document.documentMode;

// Edge 20+
const isEdge = !isIE && !!window.StyleMedia;

// Chrome 1 - 79
const isChrome = !!window.chrome
  && (!!window.chrome.webstore || !!window.chrome.runtime);

export default {
  isIE,
  isEdge,
  isChrome,
};
